export const allEvents = [
  {
    id: 1,
    title: 'InnovateX 2025 Tech Fest',
    college: 'Global Institute of Technology',
    date: 'Oct 25, 2025',
    category: 'Tech',
    imageUrl: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 2,
    title: 'Elysian 2025 - Annual Cultural Fest',
    college: 'National College of Arts',
    date: 'Nov 05, 2025',
    category: 'Cultural',
    imageUrl: 'https://images.unsplash.com/photo-1511795409834-ef04bbd51622?auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 3,
    title: 'Startup Ignition Challenge',
    college: 'Premier Business School',
    date: 'Nov 12, 2025',
    category: 'Workshop',
    imageUrl: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 4,
    title: 'Marathon 2025: Run for a Cause',
    college: 'City Sports University',
    date: 'Oct 29, 2025',
    category: 'Sports',
    imageUrl: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 5,
    title: 'CodeSprint: A 24-Hour Hackathon',
    college: 'Global Institute of Technology',
    date: 'Nov 18, 2025',
    category: 'Tech',
    imageUrl: 'https://images.unsplash.com/photo-1587620962725-abab7fe55159?auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 6,
    title: 'Symphony: The Battle of Bands',
    college: 'National College of Arts',
    date: 'Nov 22, 2025',
    category: 'Cultural',
    imageUrl: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 7,
    title: 'AI & Machine Learning Workshop',
    college: 'Global Institute of Technology',
    date: 'Dec 02, 2025',
    category: 'Workshop',
    imageUrl: 'https://images.unsplash.com/photo-1526374965328-7b61b4dcbb6c?auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 8,
    title: 'Inter-College Football Championship',
    college: 'City Sports University',
    date: 'Dec 10, 2025',
    category: 'Sports',
    imageUrl: 'https://images.unsplash.com/photo-1552667466-07770ae110d0?auto=format&fit=crop&w=1350&q=80'
  }
];

export const categories = ['All', 'Tech', 'Cultural', 'Sports', 'Workshop'];